import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { ModalModule } from 'ngx-bootstrap/modal';
import { SiteServices } from '../../services/siteservices';
import { PaginationModule } from 'ngx-bootstrap';
import { AlertModule } from 'ngx-bootstrap/alert';
import { ChartsModule } from 'ng2-charts';

import { DecimalOnlyDirective } from '../../directives/decimalonly.directive';
import { IntegerOnlyDirective } from '../../directives/integeronly.directive';
import { CurrencyOnlyDirective } from '../../directives/currencyonly.directive';
import { HUFPipe } from '../../pipes/huf.pipe';
import { RoundPipe } from '../../pipes/round.pipe';

import { RouteReuseStrategy } from '@angular/router';
import { ROOTAPPNEW_ROUTER_PROVIDERS } from './productdetail.routes';

import { CustomReuseStrategy } from '../common/route.reuse';

//import { SimpleModalComponent } from 'ngx-modal-dialog';
import { ModalDialogModule } from 'ngx-modal-dialog';

import { ProductDetailComponent } from './productdetail.main';
import { ProductDetailFrm } from './productdetail.frm';
import { FileUploadModule } from 'ng2-file-upload';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CKEditorModule } from 'ckeditor4-angular';
//import { BrowserModule } from '@angular/platform-browser';

@NgModule({
    declarations: [
        ProductDetailComponent,
        ProductDetailFrm,
        DecimalOnlyDirective,
        IntegerOnlyDirective,
        CurrencyOnlyDirective,
        HUFPipe,
        RoundPipe,
    ],
    imports: [
        ChartsModule,
        CommonModule,
        ROOTAPPNEW_ROUTER_PROVIDERS,
        CKEditorModule,
        FormsModule,
        HttpModule,
        DragDropModule,
        //   BrowserModule,
        FileUploadModule,
        PaginationModule.forRoot(),
        AlertModule.forRoot(),
        ModalModule.forRoot(),
        ModalDialogModule.forRoot(),
    ],
    providers: [
        SiteServices,
        { provide: RouteReuseStrategy, useClass: CustomReuseStrategy },
    ],
    bootstrap: [ProductDetailComponent],
})
export class ProductDetailModule {}
